import React from 'react';
import Tabs from '../UI/Tabs';

interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface ProjectTabsProps {
  tabs: Tab[];
  defaultTab?: string;
  onTabChange?: (tabId: string) => void;
}

// Re-export Tabs component as ProjectTabs for backward compatibility
const ProjectTabs: React.FC<ProjectTabsProps> = (props) => {
  return <Tabs {...props} />;
};

export default ProjectTabs;

